export const columnsDataColumns = [
  {
    Header: "Added On",
    accessor: "created_on", 
  },
  {
    Header: "Country",
    accessor: "country",
  },
  {
    Header: "Via",
    accessor: "in_channel", 
  },
  {
    Header: "User ID",
    accessor: "user_id",
  },
  {
    Header: "Names",
    accessor: "fname", 
  },
  {
    Header: "Picture",
    accessor: "profile_pic_url",
  },
  {
    Header: "Comments",
    accessor: "user_comments",
  },
  {
    Header: "Contact",
    accessor: "mobile_no",
  },
];
